import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Product } from "@components/product/ProductTypes";
import Tools from "@ts/Tools";

export default class PlanUnitCountResult extends ComponentBase
{
  sum: number = 0;

  constructor(elem: ComponentElem, data: Product.UnitCountResult)
  {
    super(elem);

    let price: any = data.data.promote_price ? data.data.promote_price : data.data.price;
    this.sum = 0;

    price = parseInt(price),
      this.sum = price * data.count;

    this.$root.find(".order-name").text(data.data.name);
    this.$root.find(".price").text(Tools.formatNumber(price));
    this.$root.find(".count").text(data.count);
    this.$root.find(".order-sum-value").text(Tools.formatNumber(this.sum));
  }

  getSum()
  {
    return this.sum;
  }
}